import { createContext, useContext, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import CONFIG from '../Services/CONFIG';

// Fetch wrapper simplified
const Http = {
  get: async (address, headers) => {
    const res = await fetch(address, { headers });
    if (!res.ok) throw new Error(res.status);
    return res.json();
  },
};

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const { user, isAuthenticated, getAccessTokenSilently, logout } = useAuth0();
  const [status, setStatus] = useState({ status: "connecting" });

  // API health check (using the server from CONFIG)
  useEffect(() => {
    async function checkApiStatus() {
      if (!isAuthenticated) return; // Skip API call if not authenticated
      try {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };
        const response = await Http.get(`${CONFIG.SERVER_ORGANIZATION}/health/connect`, headers);
        // console.log('API Status: ', response);
        setStatus({ ...response, address: CONFIG.SERVER });
      } catch (error) {
        console.error('API health check error:', error);
      }
    }
    checkApiStatus();
  }, [isAuthenticated, getAccessTokenSilently, logout, user?.permissions]);

  // Axios interceptor 
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (res) => res,
      (error) => {
        if (error.response?.status === 401) {
          logout({ returnTo: window.location.origin });
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptor);
  }, [logout]);



  return (
    <AuthContext.Provider value={{ user, isAuthenticated, getAccessTokenSilently, logout, status }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);